import "./App.css";
import React from "react";
import Hero from "./components/Hero";

const App = () => <Hero />;

export default App;
